/**
 * @file ログインフォームの入力状態を管理するステート
 *
 * ログイン画面で入力されたユーザーIDとパスワードを保持する。
 * ログイン処理完了後にこのステートの値が使われるため、
 * セッションストレージへの永続化は行わない。
 */
import { atom } from 'recoil';

/** ログインフォームの入力値型 */
export type LoginFromType = {
  /** ユーザーID */
  userId: string;
  /** パスワード */
  password: string;
};

export const loginFromState = atom<LoginFromType>({
  key: 'loginFromState',
  default: {
    userId: '',
    password: '',
  },
});

export default loginFromState;
